import React from 'react';
import { SigningAppointmentAddressForm } from '../../../../signingAppointments/SigningAppointmentAddressForm';
import { FormikContextType, useFormikContext } from 'formik';
import { IOrderDetailsData } from '../../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import { Show } from '../../../../../shared/Show';
import { IDetailsFormData } from './types/IDetailsFormData';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const PropertyAddressSection: React.FC = () => {
  const formik = useFormikContext<IDetailsFormData>();
  const { data: order } = useSelectCurrentOrder();
  return (
    <Show when={formik.values.signingMethod !== eSigningMethod.eSign}>
      <section className={css({ marginBottom: '20' })}>
        <div className={css({ marginBottom: '12' })}>
          <SigningAppointmentAddressForm
            showLocationToggle={formik.values.isDigitalScheduling}
            signerWillProvideLocation={formik.values.signerWillProvideLocation}
            isLegacy={!formik.values.isDigitalScheduling}
            isSignatureSync={formik.values.isSignatureSyncAppointment}
          />
        </div>
        <Show when={!formik.values.signerWillProvideLocation}>
          <Button
            tone={'neutral'}
            emphasis={'outlined'}
            size="sm"
            onClick={() => onChangeSameAsPropertyAddress(formik, order)}
          >
            Copy property address
          </Button>
        </Show>
      </section>
    </Show>
  );
};

const onChangeSameAsPropertyAddress = (formik: FormikContextType<IDetailsFormData>, order: IOrderDetailsData) => {
  if (!sameAsPropertyAddress(formik.values, order)) {
    formik.setFieldTouched('address.stateAbbreviation');
    formik.setValues({
      ...formik.values,
      address: {
        streetAddress: order.property.street_address ?? '',
        unit: order.property.unit ?? undefined,
        city: order.property.city ?? '',
        stateAbbreviation: order.property.state ?? '',
        zipCode: order.property.zip_code ?? '',
      },
    });
  }
};

const sameAsPropertyAddress = (values: IDetailsFormData, order: IOrderDetailsData): boolean => {
  return (
    !!values.address &&
    values.address.streetAddress === order.property.street_address &&
    values.address.unit === order.property.unit &&
    values.address.city === order.property.city &&
    values.address.stateAbbreviation === order.property.state &&
    values.address.zipCode === order.property.zip_code
  );
};
